// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4b36e8c7","453":"2380698d","455":"f25c5eab","977":"a614f169"}[chunkId] + ".chunk.js";
};